import { ClientSideExperiment } from "@flights/types";
import { customGoal, stage as trackEtStage } from "@flights/et-universal";
import { isOfMetaOrigin } from "./marketing-url-params";

// This file is a wrapper for easily tracking meta related experiments

export const trackMetaExperimentStage = (expName: ClientSideExperiment, stage: number) => {
  const isMeta = isOfMetaOrigin();
  if (isMeta) {
    trackEtStage(expName, stage);
  }
};

export const trackMetaCustomGoal = (expName: ClientSideExperiment, goal: number) => {
  const isMeta = isOfMetaOrigin();
  if (isMeta) {
    customGoal(expName, goal);
  }
};
